<template>
	<div class="physician-table">
		<div class="maincontent__double-header-wrapper">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Stolik lekarza</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small>
					<br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>
		<div class="physician-table__main">
			<div class="physician-table__options">
				<div class="physician-table__radios">
					<SingleChoice
						lead="Jakie rękawy preferujesz?"
						description="Wybierz jedną z opcji:"
						prop="hoseOrientation"
						propSetter="setHoseOrientation"
						:options="hoseOrientationOptions"
					/>
					<SingleChoice
						lead="Ilu instrumentów potrzebujesz?"
						description="Wybierz jedną z opcji:"
						prop="instrumentCount"
						propSetter="setInstrumentCount"
						:options="instrumentCountOptions"
					/>
				</div>
				<div class="physician-table__preview">
					<img class="physician-table__image" :src="imgSrc" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import SingleChoice from '../SingleChoice';
import AppDataMixin from '@/mixins/app-data';
import {calculateTableImageNumber} from '@/core/helpers/table-image-number.helpers';

export default {
	name: 'PhysicialTable',
	mixins: [AppDataMixin],
	components: {SingleChoice},
	computed: {
		imgSrc() {
			const tableImageNumber = calculateTableImageNumber(
				this.hoseOrientation.name,
				this.instrumentCount.name
			);

			return require(`@/assets/pictures/stolik-${tableImageNumber}.jpg`);
		},
		hoseOrientationOptions() {
			return R.pipe(
				R.keys,
				R.map(o => ({text: o === 'up' ? 'od góry' : 'od dołu', value: o}))
			)(this.getAppData('hoseOrientations'));
		},
		instrumentCountOptions() {
			return R.pipe(
				R.keys,
				R.map(i => ({text: parseInt(i, 10), value: parseInt(i, 10)}))
			)(this.getAppData('instrumentCounts'));
		},
	},
};
</script>
